import { AssessmentOrder } from "../../../system/Domain";
import { green, orange } from "@mui/material/colors";
import { Chip } from "@mui/material";
import TextBlock from "../../../Components/Layout/TextBlock";

interface Props {
	assessmentOrder: AssessmentOrder
}

const dekraAssessmentStatusSettings = {
	"Unknown": {
		label: "Unbekannt",
		backgroundColor: orange[500]
	},
	"Transferred": {
		label: "Übertragen",
		backgroundColor: green[500]
	},
	"Delayed": {
		label: "Verzögert",
		backgroundColor: orange[500]
	},
	"Confirmed": {
		label: "Bestätigt",
		backgroundColor: green[500]
	},
	"Assigned": {
		label: "Zugewiesen",
		backgroundColor: green[500]
	},
	"Cancelled": {
		label: "Storniert",
		backgroundColor: orange[500]
	},
	"Done": {
		label: "Abgeschlossen",
		backgroundColor: green[500]
	}
};

const DekraAssessmentOrderStatusPill = (props:Props) => {
	const setting = dekraAssessmentStatusSettings[props.assessmentOrder.assessmentStatus];

	return (
		<TextBlock
			primary={
				<Chip
					label={setting.label}
					size="small"
					style={{ backgroundColor: setting.backgroundColor }}
				/>
			}
			// secondary={setting.date(props.assessmentOrder)}
		/>
	);
};

export default DekraAssessmentOrderStatusPill;
